var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "71px",
    height: "48px",
    viewBox: "0 0 71 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "France-3@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flags",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-324.000000, -744.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.000000, 70.000000)",
    fillRule: "nonzero",
    id: "France-3"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(254.000000, 674.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Belgium-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bahamas-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.51,0.11 C2.99746899,0.11 0.15,2.95746899 0.15,6.47 L0.15,40.74 C0.15,44.252531 2.99746899,47.1 6.51,47.1 L23.51,47.1 C23.51,31.4333333 23.51,15.7666667 23.51,0.1 L6.51,0.11 Z",
    id: "Shape",
    fill: "#4758A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.49,0.11 C23.49,15.7766667 23.49,31.4433333 23.49,47.11 L46.84,47.11 C46.84,31.4433333 46.84,15.7766667 46.84,0.11 L23.49,0.11 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.78,0.11 L46.83,0.11 C46.83,15.7766667 46.83,31.4433333 46.83,47.11 L63.78,47.11 C67.292531,47.11 70.14,44.262531 70.14,40.75 L70.14,6.48 C70.1426549,4.79149117 69.4737576,3.17123007 68.2807384,1.97633501 C67.0877191,0.781439956 65.4685109,0.109997913 63.78,0.11 Z",
    id: "Shape",
    fill: "#ED5565"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrance);
export default __webpack_public_path__ + "static/media/france.d3794f02d7e91e911287b47ab69ecb7a.svg";
export { ForwardRef as ReactComponent };